import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../api/client';

const CatalogContext = createContext(null);

export function CatalogProvider({ children }) {
  const [catalog, setCatalog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/catalog/all')
      .then(res => {
        setCatalog(res.data);
        setLoading(false);
      })
      .catch(() => {
        // Fallback - catalog should always be available even without auth
        setLoading(false);
      });
  }, []);

  return (
    <CatalogContext.Provider value={{ catalog, loading }}>
      {children}
    </CatalogContext.Provider>
  );
}

export function useCatalog() {
  const ctx = useContext(CatalogContext);
  if (!ctx) throw new Error('useCatalog must be used within CatalogProvider');
  return ctx;
}

// Helper hooks for specific data
export function useCosmeticCatalog() {
  const { catalog } = useCatalog();
  return catalog?.cosmetics || [];
}

export function useCosmeticSlots() {
  const { catalog } = useCatalog();
  return catalog?.cosmetic_slots || {};
}

export function useFoodCatalog() {
  const { catalog } = useCatalog();
  return catalog?.foods || [];
}

export function useFoodFavorites() {
  const { catalog } = useCatalog();
  return catalog?.food_favorites || {};
}

export function useAbilities() {
  const { catalog } = useCatalog();
  return catalog?.abilities || [];
}

export function usePetTiers() {
  const { catalog } = useCatalog();
  return catalog?.pet_tiers || {};
}

export function usePetPrices() {
  const { catalog } = useCatalog();
  return catalog?.pet_prices || { free: 0, plus: 80, premium: 200, individual: 300 };
}

export function useSlotPrices() {
  const { catalog } = useCatalog();
  return catalog?.slot_prices || [0, 0, 200, 400, 600, 800, 1200, 1600, 2200, 3000];
}

export function usePets() {
  const { catalog } = useCatalog();
  return catalog?.pets || [];
}

export default CatalogContext;
